module.exports = __webpack_public_path__ + "static/img/static-zoom-county-1-core.195d60f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static-zoom-county-1-core.png
// module id = 73
// module chunks = 0